<template>
    <div style="margin-top: 24px;">
        <strong>Política de Privacidade</strong> <p>
        Quiz & Jogos Online desenvolveu o aplicativoDevocional Diário Evangélico como
        um aplicativo com Anúncios. Este SERVIÇO é fornecido por
        Quiz & Jogos Online gratuitamente e destina-se a ser utilizado como
        está.
    </p> <p>
        Esta página é usada para informar os visitantes sobre
        minhas políticas com a coleta, uso e divulgação de Informações Pessoais
        caso alguém decida utilizar meu serviçoDevocional Diário Evangélico.
    </p> <p>
        Se você optar por utilizar meu Serviço, então você concorda com
        a coleta e uso de informações em relação a esta
        política. As Informações Pessoais que eu recolho são
        utilizadas para fornecer e melhorar o Serviço. Eu não irei utilizar ou compartilhar suas informações com
        ninguém, exceto conforme descrito nesta Política de Privacidade.
    </p> <p>
        Os termos utilizados nesta Política de Privacidade têm os mesmos significados
        que em nossos Termos e Condições, acessíveis em
       Devocional Diário Evangélico, a menos que definido de outra forma nesta Política de Privacidade.
    </p> <p><strong>Coleta e Uso de Informações</strong></p> <p>
        Para uma melhor experiência, ao utilizar nosso Serviço, eu
        posso exigir que você nos forneça certas informações de identificação pessoal, incluindo, mas não se limitando a nome, e-mail. As informações que
        solicito serão retidas no seu dispositivo e não são coletadas por mim de nenhuma forma.
    </p> <div><p>
        O aplicativo usa serviços de terceiros que podem coletar
        informações usadas para identificá-lo.
        </p> <p>
        Link para a política de privacidade dos prestadores de serviços de terceiros utilizados
        pelo aplicativo
        </p> <ul><li><a href="https://www.google.com/policies/privacy/" target="_blank" rel="noopener noreferrer">Serviços do Google Play</a></li><li><a href="https://support.google.com/admob/answer/6128543?hl=en" target="_blank" rel="noopener noreferrer">AdMob</a></li><li><a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer">Google Analytics para Firebase</a></li><li><a href="https://firebase.google.com/support/privacy/" target="_blank" rel="noopener noreferrer">Firebase Crashlytics</a></li></ul></div> <p><strong>Dados de Registro</strong></p> <p>
        Eu quero informar que sempre que você
        usar meu Serviço, em caso de erro no aplicativo
        eu coleto dados e informações (através de produtos de terceiros)
        no seu telefone chamados Dados de Registro. Estes Dados de Registro podem
        incluir informações como o endereço IP do seu dispositivo, nome do dispositivo, versão do sistema operacional, a
        configuração do aplicativo ao utilizar meu Serviço,
        o horário e a data do uso do Serviço e outras estatísticas.
    </p> <p><strong>Cookies</strong></p> <p>
        Cookies são arquivos com uma pequena quantidade de dados que são
        comumente usados como identificadores exclusivos anônimos. Estes são enviados
        para o seu navegador a partir dos sites que você visita e são
        armazenados na memória interna do seu dispositivo.
    </p> <p>
        Este Serviço não utiliza esses “cookies” explicitamente. No entanto,
        o aplicativo pode usar código de terceiros e bibliotecas que usam
        “cookies” para coletar informações e melhorar seus serviços.
        Você tem a opção de aceitar ou recusar esses cookies
        e saber quando um cookie está sendo enviado para o seu dispositivo. Se você
        optar por recusar nossos cookies, você pode não ser capaz de usar algumas
        partes deste Serviço.
    </p> <p><strong>Prestadores de Serviços</strong></p> <p>
        Eu posso empregar empresas terceirizadas e
        indivíduos pelos seguintes motivos:
    </p> <ul><li>Para facilitar nosso Serviço;</li> <li>Para fornecer o Serviço em nosso nome;</li> <li>Para realizar serviços relacionados com o Serviço; ou</li> <li>Para nos ajudar a analisar como nosso Serviço é utilizado.</li></ul> <p>
        Eu quero informar aos usuários deste Serviço
        que esses terceiros têm acesso às suas Informações Pessoais. O motivo é executar as tarefas atribuídas a
        eles em nosso nome. No entanto, eles são obrigados a não
        divulgar ou usar as informações para qualquer outra finalidade.
    </p> <p><strong>Segurança</strong></p> <p>
        Eu valorizo a sua confiança ao nos fornecer suas
        Informações Pessoais, assim estamos nos esforçando para usar meios
        comercialmente aceitáveis de protegê-las. Mas lembre-se de que nenhum método
        de transmissão pela internet, ou método de armazenamento eletrônico é 100% seguro e confiável, e eu não posso
        garantir sua segurança absoluta.
    </p> <p><strong>Links para Outros Sites</strong></p> <p>
        Este Serviço pode conter links para outros sites. Se você clicar em
        um link de terceiros, você será direcionado para esse site. Observe
        que esses sites externos não são operados por mim.
        Portanto, eu recomendo fortemente que você reveja a
        Política de Privacidade desses sites. Eu
        não tenho controle e não assumo responsabilidade pelo conteúdo,
        políticas de privacidade ou práticas de sites ou serviços de terceiros.
    </p> <p><strong>Privacidade de Crianças</strong></p> <div><p>
        Estes Serviços não se destinam a menores de 13 anos. Eu não recolho
        conscientemente informações de identificação pessoal de crianças com menos de 13 anos. No caso
        de descobrir que uma criança menor de 13 anos nos forneceu
        informações pessoais, eu as excluo imediatamente
        dos nossos servidores. Se você é pai ou mãe ou responsável e está ciente de que
        seu filho nos forneceu informações pessoais, entre em contato comigo para que
        eu possa tomar as medidas necessárias.
        </p></div> <p><strong>Alterações a Esta Política de Privacidade</strong></p> <p>
        Eu posso atualizar nossa Política de Privacidade de
        tempos em tempos. Portanto, recomendamos que você revise esta página
        periodicamente para verificar se há alterações. Eu irei
        notificá-lo de quaisquer alterações postando a nova Política de Privacidade nesta página.
    </p> <p>Esta política é eficaz a partir de 2024-02-22</p> <p><strong>Entre em Contato</strong></p> <p>
        Se você tiver alguma dúvida ou sugestão sobre minha
        Política de Privacidade, não hesite em entrar em contato comigo pelo e-mail quizejogosonline@gmail.com.</p>
   </div>
    <strong>Termos e Condições</strong>
    <p>
        Ao baixar ou usar o aplicativo, estes termos serão
        aplicados automaticamente a você - portanto, certifique-se
        de lê-los atentamente antes de usar o aplicativo. Você não
        tem permissão para copiar ou modificar o aplicativo, qualquer
        parte dele, ou nossas marcas registradas de qualquer forma. Você
        não tem permissão para tentar extrair o código-fonte do aplicativo,
        e também não deve tentar traduzir o aplicativo para outros idiomas ou
        criar versões derivadas. O próprio aplicativo, e todas as marcas registradas,
        direitos autorais, direitos de banco de dados e outros direitos de propriedade intelectual
        relacionados a ele, ainda pertencem a Quiz & Jogos Online.
    </p>
    <p>
        Quiz & Jogos Online está comprometido em garantir que o aplicativo seja
        o mais útil e eficiente possível. Por essa razão, nos
        reservamos o direito de fazer alterações no aplicativo ou cobrar por
        seus serviços, a qualquer momento e por qualquer motivo. Nós nunca
        iremos cobrar você pelo aplicativo ou seus serviços sem deixar muito
        claro exatamente pelo que você está pagando.
    </p>
    <p>
        O aplicativo Devocional Diário Evangélico armazena e processa dados pessoais que
        você nos forneceu, para fornecer meu
        Serviço. É sua responsabilidade manter seu telefone e
        acesso ao aplicativo seguro. Portanto, recomendamos que você não
        faça jailbreak ou root em seu telefone, que é o processo de
        remoção de restrições e limitações de software impostas pelo
        sistema operacional oficial do seu dispositivo. Isso pode tornar seu
        telefone vulnerável a malware/vírus/programas maliciosos,
        comprometer os recursos de segurança do seu telefone e pode significar
        que o aplicativo Devocional Diário Evangélico não funcionará corretamente ou de forma alguma.
    </p>
    <div>
        <p>
            O aplicativo usa serviços de terceiros que declaram seus
            Termos e Condições.
        </p>
        <p>
            Link para os Termos e Condições dos provedores de serviços de terceiros
            usados pelo aplicativo
        </p>
        <ul>
            <li><a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">Google Play
                    Services</a></li>
            <li><a href="https://developers.google.com/admob/terms" target="_blank" rel="noopener noreferrer">AdMob</a>
            </li>
            <li><a href="https://www.google.com/analytics/terms/" target="_blank" rel="noopener noreferrer">Google
                    Analytics for Firebase</a></li>
            <li><a href="https://firebase.google.com/terms/crashlytics" target="_blank"
                    rel="noopener noreferrer">Firebase Crashlytics</a></li>
            <!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!---->
            <li><a href="https://onesignal.com/tos" target="_blank" rel="noopener noreferrer">One Signal</a></li>
            <!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!---->
        </ul>
    </div>
    <p>
        Você deve estar ciente de que há certas coisas pelas quais
        Quiz & Jogos Online não se responsabilizará. Certas
        funções do aplicativo exigirão que o aplicativo tenha uma conexão
        à internet ativa. A conexão pode ser Wi-Fi ou fornecida
        pelo seu provedor de rede móvel, mas Quiz & Jogos Online
        não pode se responsabilizar pelo aplicativo não funcionar com
        funcionalidade total se você não tiver acesso ao Wi-Fi e não tiver
        nenhum de seus dados de conexão restantes.
    </p>
    <p></p>
    <p>
        Se você estiver usando o aplicativo fora de uma área com Wi-Fi, você
        deve lembrar que os termos do acordo com seu
        provedor de rede móvel ainda se aplicarão. Como resultado, você pode
        ser cobrado pelo seu provedor móvel pelo custo dos dados durante
        a conexão ao acessar o aplicativo, ou
        outras cobranças de terceiros. Ao usar o aplicativo, você está
        aceitando a responsabilidade por tais cobranças, incluindo cobranças
        de roaming de dados se você usar o aplicativo fora do seu território
        doméstico (ou seja, região ou país) sem desativar o roaming de dados. Se
        você não for o pagador da conta do dispositivo em que você está
        usando o aplicativo, esteja ciente de que assumimos que você tem
        permissão do pagador da conta para usar o aplicativo.
    </p>
    <p>
        Da mesma forma, Quiz & Jogos Online nem sempre pode se responsabilizar
        pela forma como você usa o aplicativo, ou seja, você precisa
        garantir que seu dispositivo esteja carregado - se ele ficar sem
        bateria e você não puder ligá-lo para utilizar o Serviço,
        Quiz & Jogos Online não pode aceitar responsabilidade.
    </p>
    <p>
        Com relação à responsabilidade de Quiz & Jogos Online pelo seu
        uso do aplicativo, quando você está usando o aplicativo, é importante
        ter em mente que, embora nos esforcemos para garantir que esteja
        atualizado e correto o tempo todo, dependemos de terceiros
        para fornecer informações para nós, para que possamos disponibilizá-las
        para você. Quiz & Jogos Online não aceita nenhuma responsabilidade por
        qualquer perda, direta ou indireta, que você possa ter como resultado de
        confiar exclusivamente nesta funcionalidade do aplicativo.
    </p>
    <p>
        Em algum momento, podemos desejar atualizar o aplicativo. O aplicativo
        está atualmente disponível no Android - os requisitos para o
        sistema (e para quaisquer sistemas adicionais que
        decidirmos estender a disponibilidade do aplicativo) podem mudar,
        e você precisará baixar as atualizações se quiser continuar
        usando o aplicativo. Quiz & Jogos Online não promete que sempre
        atualizará o aplicativo para que seja relevante para você
        e/ou funcione com a versão do Android que você tem
        instalada no seu dispositivo. No entanto, você se compromete a sempre
        aceitar atualizações do aplicativo quando oferecidas a você. Também podemos
        desejar parar de fornecer o aplicativo, e podemos encerrar o uso
        dele a qualquer momento sem aviso prévio a você. A menos que
        digamos o contrário, após qualquer rescisão, (a) os
        direitos e licenças concedidos a você nestes termos terminarão;
        (b) você deve parar de usar o aplicativo e (se necessário) excluí-lo
        do seu dispositivo.
    </p>
    <p><strong>Alterações a Este Termos e Condições</strong></p>
    <p>
        Eu posso atualizar nossos Termos e Condições
        de tempos em tempos. Assim, você é aconselhado a revisar esta página
        periodicamente para quaisquer alterações. Eu irei
        notificá-lo de quaisquer alterações publicando os novos Termos e
        Condições nesta página.
    </p>
    <p>
        Estes termos e condições são eficazes a partir de 2024-02-22
    </p>
    <p><strong>Contate-Nos</strong></p>
    <p>
        Se você tiver alguma dúvida ou sugestão sobre meus
        Termos e Condições, não hesite em me contatar
        em quizejogosonline@gmail.com.
    </p>

</template>

<script>
export default {
    name: "LeituraBiblicaDiariaPrivacyPolicy"
}
</script>